import React from "react";
import { Col, Row } from "antd";
import { Divider, List, Card, Space } from "antd";
import RadiologyReport from "./RadiologyReport";


const data = [
  { modality: "CT", date: "April 15, 2023", report: "THORAX WITHOUT CCN" },
];



const PageReport = () => {
  return (
    <>
      <Row gutter={16}>
        <Col span={6}>
          <Divider orientation="left">Patient Reports</Divider>
          <List
            size="large"
            header={
              <>
                <div>Patient: Peter Doe [OUT | 54| M]</div>
                <div>MRN: 988902234</div>
                <div>DOB: 12/12/1967</div>
              </>
            }
            // footer={<div>Status: Ready</div>}
            // bordered
            dataSource={data}
            renderItem={(item) => (
              <Card size="small" style={{ margin: "3px" }}>
                <p>{`${item.modality} - ${item.report}`}</p>
                <p>{item.date}</p>
                <Space>
                  <a
                    href="http://18.208.133.128/viewer?StudyInstanceUIDs=1.3.6.1.4.1.5962.1.1.0.0.0.1194734704.16302.0.1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Viewer
                  </a>
                </Space>
              </Card>
            )}
          />
        </Col>
        <Col span={18}>
          <Card>
            <RadiologyReport />
          </Card>
        </Col>
      </Row>
     
    </>
  );
};

export default PageReport;
